import React from 'react'
import { Link } from 'react-router-dom'
import '../subscriptionTabs/SubscriptionTab.css'

const SubscriptionTab = () => {
  return (
    <div className='tabs-detail-sec subscription-tab'>
        <div className='subscription-box'>
            <h2>Subscription</h2>
            <div className='subscription-content-details'>
                <div className='subscription-group mb-3 d-flex flex-wrap align-items-center justify-content-between'>
                    <div className='amount'>
                        <span>Monthly</span>
                        <span>$29.99</span>
                    </div>
                    <Link rel='stylesheet' to="/" className='btn btn-border'>Selected</Link>
                </div>
                <div className='subscription-group mb-3  d-flex flex-wrap align-items-center'>
                    <div className='amount'>
                        <span>Annual</span>
                        <span>$299.99 </span>
                    </div>
                </div>
                <div className='btn btn-box d-flex justify-content-end w-100'>
                    <Link rel='stylesheet' to="/" className='btn btn-border'>Cancel</Link>
                </div>
            </div>
        </div>
    </div>
  )
}

export default SubscriptionTab
